import FoodItem from './FoodItem';

export default FoodItem;
